import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const getPatientsList = async (
  token,
  q = null,
  page = null,
  pageSize = null
) => {
  const endpoint =
    q === null
      ? `/api/v1/admin/patients?page=${page}&per_page=${pageSize}`
      : `/api/v1/admin/patients?page=${page}&per_page=${pageSize}${
          q ? `&q=${q}&type=filter_admin` : ""
        }`;
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      toast.error(data?.status?.message || "something went wrong");
    }
  } catch (error) {
    toast.error(error.message || "something went wrong");
  }
};
